export default class ShowcaseOverview {
    constructor() {
        this.loader = document.querySelector('.js-loader');
        this.listContainer = document.querySelector('.js-showcase-list');
        this.searchForm = document.querySelector('#searchForm');
        this.isLoading = false;

        if (this.loader && this.listContainer && this.searchForm) {
            this.initObserver();
        }
    }

    initObserver() {
        this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
            rootMargin: '100px',
        });

        this.observer.observe(this.loader);
    }

    async onIntersect([entry]) {
        if (!entry.isIntersecting || this.isLoading) {
            return;
        }

        this.isLoading = true;

        const page = parseInt(this.loader.dataset.page, 10) || 2;
        const url = this.loader.dataset.url;
        const filterType = this.listContainer.dataset.filterType;

        const formData = new FormData(this.searchForm);
        const params = new URLSearchParams();

        for (const [key, value] of formData.entries()) {
            params.append(`filter.${key}`, value);
        }

        if (filterType) {
            params.set('filter.Type', filterType);
        }

        params.set('page', page);

        try {
            const response = await fetch(`${url}?${params.toString()}`, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            if (response.ok) {
                const html = await response.text();
                const temp = document.createElement('div');
                temp.innerHTML = html;

                const newCards = temp.querySelectorAll('.showcase-card');

                if (newCards.length > 0) {
                    newCards.forEach(card => this.listContainer.appendChild(card));
                    this.loader.dataset.page = page + 1;
                } else {
                    this.observer.unobserve(this.loader);
                    this.loader.remove();
                }
            } else {
                this.observer.unobserve(this.loader);
            }
        } catch (err) {
            this.observer.unobserve(this.loader);
        } finally {
            this.isLoading = false;
        }
    }
}
